/*
 *  Document   : client-edit.js
 *  Author     : Exapoint
 *
 */

// Import required modules

import ExaHelpers from "../exa_helpers";

export default class ClientProfileEdit {

    /*
    * Auto called when creating a new instance
    *
    */
    constructor() {
        window["ClientProfileEdit"] = this;
        this.init();
    }

    init() {
        ExaHelpers.validation();
        this.initValidation();

        if (jsVars.showEmptyCompanyAlert) {
            this.showEmptyCompanyAlert();
        }
    }

    initValidation() {
        $('.js-validation').validate({
            ignore: [],
            rules: {
                'gender_id': {
                    required: true,
                },
                'first_name': {
                    required: true,
                },
                'last_name': {
                    required: true,
                },
                'email': {
                    required: true,
                },
                'mobile_number_intl': {
                    required: true,
                    intlTelNumber: true,
                },
            },
        });

    }

    showEmptyCompanyAlert() {
        let e = Swal.mixin({
            buttonsStyling: !1,
            customClass: {
                confirmButton: "btn btn-success m-1",
                cancelButton: "btn btn-danger m-1",
                input: "form-control"
            }
        });

        e.fire({
            title: '',
            text: '',
            icon: "success",
            showCancelButton: 1,
            customClass: {confirmButton: "btn btn-success m-1", cancelButton: "btn btn-danger m-1"},
            confirmButtonText: jsVars.companyText,
            cancelButtonText: jsVars.closeText,
            html: jsVars.emptyCompanyText,
            preConfirm: function (e) {
                window.location = jsVars.companyUrl;
            }
        })
    }
}
